export default __webpack_public_path__ + "static/media/default-image.e74b033c.svg";